/* ==========================================================
   מגירת העגלה – הסכום הכולל על כפתור "תשלום מאובטח" ("• 469 ₪"),
   והזזה מיידית של הסוויץ' של ביטוח המשלוח בלחיצה.
   הסכום נלקח מ-.gb-totals-total-value (אגורות, מתרנדר מחדש עם המגירה)
   ומתעדכן בכל רינדור של המגירה. משלים את assets/claude-cart-drawer.css.
   ========================================================== */
(function () {
  'use strict';

  function fmt(cents) {
    var n = cents / 100;
    return (Math.round(n * 100) % 100 === 0 ? String(Math.round(n)) : n.toFixed(2)) + ' ₪';
  }

  /* סידור מחדש אחרי כל רינדור של המגירה (פעולה חוזרת – לא מזיזה פעמיים):
     - תג המבצע של כל מוצר עובר מתחת לשם המוצר;
     - המחיר של ביטוח המשלוח עובר מעל הסוויץ'. */
  // מוצרי אפסל (מארז ה-VIP): ה-handle מתוך ה-ProductJson של האפסלים בעמוד, ובנוסף ה-handle הקבוע
  var UPSELL_HANDLES = ['מנוי-חודשי-source'];

  function upsellHandles() {
    var list = UPSELL_HANDLES.slice();
    document.querySelectorAll('.ccu script[id^="ProductJson-"], .claude-upsell-checkbox script[id^="ProductJson-"]').forEach(function (s) {
      try {
        var h = JSON.parse(s.textContent).handle;
        if (h && list.indexOf(h) === -1) list.push(h);
      } catch (e) {}
    });
    return list;
  }

  function isUpsellRow(row, handles) {
    var link = row.querySelector('a.cart-item__name, a.cart-item__link');
    if (!link) return false;
    var path = '';
    try { path = decodeURIComponent(new URL(link.href, location.href).pathname); } catch (e) { return false; }
    return handles.some(function (h) { return path.indexOf('/products/' + h) !== -1; });
  }

  // המארז שנבחר ראשון, ומארז ה-VIP (האפסל) אחריו – העגלה מציגה את המוצר האחרון שנוסף למעלה.
  // השורות רק מוזזות בתצוגה; מספר השורה (data-index) לא משתנה, כך שכפתורי הכמות ממשיכים לעבוד.
  function upsellLast(drawer) {
    var rows = drawer.querySelectorAll('tr.cart-item');
    if (rows.length < 2) return;
    var handles = upsellHandles();
    var parent = rows[0].parentElement;
    var upsells = [];
    var sawRegular = false;
    var needsMove = false;
    rows.forEach(function (row) {
      if (isUpsellRow(row, handles)) {
        upsells.push(row);
      } else {
        if (upsells.length) needsMove = true;
        sawRegular = true;
      }
    });
    if (!sawRegular || !needsMove) return;
    upsells.forEach(function (row) {
      parent.appendChild(row);
      // הזזה מנתקת לרגע את השורה, ואז cart-remove-button מסיר את מאזין הלחיצה שלו
      // (disconnectedCallback) ולא מחזיר אותו – מחזירים אותו כאן כדי שהפח ימשיך לעבוד
      row.querySelectorAll('cart-remove-button').forEach(function (btn) {
        if (btn.clickHandler) btn.addEventListener('click', btn.clickHandler);
      });
    });
  }

  // כפתור "פרטים" גם על מארז ה-VIP אחרי שנוסף לעגלה – פותח את אותו תיאור של האפסל.
  // התיאור נשמר מהאפסל כשהוא מוצג (sessionStorage), ואם אין – נלקח מתיאור המוצר.
  var INFO_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="11" x2="12" y2="16"/><circle cx="12" cy="7.5" r="0.6" fill="currentColor"/></svg>';
  var infoCache = {};

  function rememberUpsellInfo(drawer) {
    drawer.querySelectorAll('.ccu').forEach(function (box) {
      var json = box.querySelector('script[id^="ProductJson-"]');
      var body = box.querySelector('.ccu-pop-body');
      if (!json || !body) return;
      try {
        var handle = JSON.parse(json.textContent).handle;
        infoCache[handle] = body.innerHTML;
        sessionStorage.setItem('ccd-info-' + handle, body.innerHTML);
      } catch (e) {}
    });
  }

  function upsellInfo(handle, done) {
    if (infoCache[handle]) return done(infoCache[handle]);
    try {
      var saved = sessionStorage.getItem('ccd-info-' + handle);
      if (saved) { infoCache[handle] = saved; return done(saved); }
    } catch (e) {}
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { infoCache[handle] = p.description || ''; done(infoCache[handle]); })
      .catch(function () { done(''); });
  }

  function rowHandle(row, handles) {
    var link = row.querySelector('a.cart-item__name, a.cart-item__link');
    if (!link) return '';
    var path = '';
    try { path = decodeURIComponent(new URL(link.href, location.href).pathname); } catch (e) { return ''; }
    for (var i = 0; i < handles.length; i++) {
      if (path.indexOf('/products/' + handles[i]) !== -1) return handles[i];
    }
    return '';
  }

  function vipInfoButtons(drawer) {
    var handles = upsellHandles();
    drawer.querySelectorAll('tr.cart-item').forEach(function (row) {
      if (row.querySelector('.ccd-vip')) return;
      var handle = rowHandle(row, handles);
      if (!handle) return;
      // הכפתור בשורה אחת עם התג "הנחת מנוי חודשי", והחלונית נפתחת מתחתם
      var tag = row.querySelector('.cart-item__discount-allocations');
      var anchor = tag || row.querySelector('.cart-item__name');
      if (!anchor) return;
      var wrap = document.createElement('div');
      wrap.className = 'ccd-vip';
      wrap.innerHTML = '<div class="ccd-vip-line"><button type="button" class="ccu-info-btn ccd-vip-btn" aria-expanded="false">' + INFO_ICON + '<span>פרטים</span></button></div>' +
        '<div class="ccu-pop ccd-vip-pop" role="region"><button type="button" class="ccu-pop-close ccd-vip-close" aria-label="סגירה">&times;</button><div class="ccu-pop-body"></div></div>';
      anchor.insertAdjacentElement(tag ? 'beforebegin' : 'afterend', wrap);
      if (tag) wrap.querySelector('.ccd-vip-line').insertBefore(tag, wrap.querySelector('.ccd-vip-btn'));
      upsellInfo(handle, function (html) {
        if (!html) { wrap.remove(); return; }
        wrap.querySelector('.ccu-pop-body').innerHTML = html;
      });
    });
  }

  function arrange(drawer) {
    rememberUpsellInfo(drawer);
    upsellLast(drawer);
    drawer.querySelectorAll('.cart-item').forEach(function (item) {
      var tag = item.querySelector('.cart-item__quantity .cart-item__discount-allocations');
      var name = item.querySelector('.cart-item__name');
      if (tag && name && name.parentElement && !tag.closest('.ccd-vip')) name.insertAdjacentElement('afterend', tag);
    });
    // אחרי שהתג כבר עבר מתחת לשם – מצמידים אליו את "פרטים" של מארז ה-VIP
    vipInfoButtons(drawer);

    var sp = drawer.querySelector('.gb-shipping-protection');
    var sw = sp && sp.querySelector('.gb-shipping-protection-button label.switch');
    if (sw && !sw.querySelector('.ccd-knob')) {
      var knob = document.createElement('span');
      knob.className = 'ccd-knob';
      knob.setAttribute('aria-hidden', 'true');
      sw.appendChild(knob);
    }
    if (sp) {
      var price = sp.querySelector('.gb-shipping-protection-icontext h2 span');
      var col = sp.querySelector('.gb-shipping-protection-button');
      if (price && col) {
        price.classList.add('ccd-sp-price');
        col.insertBefore(price, col.firstChild);
      }
    }

    // "משלוח חינם | 60 ימי אחריות" מתחת לכפתור התשלום – שני פריטים עם אייקונים
    var promise = drawer.querySelector('h2.gb-30day-back');
    if (promise && !promise.querySelector('.ccd-promise')) {
      var parts = promise.textContent.split(/[|+•]/).map(function (s) { return s.trim(); }).filter(Boolean);
      if (parts.length) {
        var icons = {
          ship: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6.5h11v9H3z"/><path d="M14 9.5h3.6l3.4 3.4v2.6h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>',
          shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7.5 3v5.5c0 4.6-3.2 8.1-7.5 9.5-4.3-1.4-7.5-4.9-7.5-9.5V6z"/><path d="M8.8 12.2l2.2 2.2 4.3-4.4"/></svg>'
        };
        promise.innerHTML = parts.map(function (text) {
          var icon = /משלוח/.test(text) ? icons.ship : icons.shield;
          return '<span class="ccd-promise">' + icon + '<span></span></span>';
        }).join('');
        promise.querySelectorAll('.ccd-promise > span').forEach(function (el, i) { el.textContent = parts[i]; });
      }
    }
  }

  function update() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) arrange(drawer);
    var button = document.getElementById('CartDrawer-Checkout');
    if (!drawer || !button) return;

    var valueEl = drawer.querySelector('.gb-totals-total-value');
    var cents = valueEl ? parseInt(valueEl.textContent.replace(/[^\d]/g, ''), 10) : NaN;

    var total = button.querySelector('.ccd-total');
    var dot = button.querySelector('.ccd-dot');
    if (isNaN(cents) || cents <= 0 || drawer.classList.contains('is-empty')) {
      if (total) total.remove();
      if (dot) dot.remove();
      return;
    }

    if (!total) {
      dot = document.createElement('span');
      dot.className = 'ccd-dot';
      dot.setAttribute('aria-hidden', 'true');
      button.appendChild(dot);
      total = document.createElement('span');
      total.className = 'ccd-total';
      button.appendChild(total);
    }
    var text = fmt(cents);
    if (total.textContent !== text) total.textContent = text;
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; update(); }, 50);
  }

  /* הסוויץ' של ביטוח המשלוח: מזיזים את הכפתור העגול מיד בלחיצה
     (ccd-on / ccd-off), עוד לפני שהעגלה מתרנדרת מחדש עם המצב החדש */
  document.addEventListener('click', function (e) {
    var label = e.target.closest && e.target.closest('.gb-shipping-protection-button label.switch');
    if (!label || e.target.tagName === 'INPUT') return;
    var on = !label.classList.contains('checked');
    label.classList.remove('ccd-on', 'ccd-off');
    label.classList.add(on ? 'ccd-on' : 'ccd-off');
  }, true);

  /* האפסל במגירה (snippets/cart-drawer-upsell.liquid):
     סימון הצ'קבוקס = הוספה לעגלה דרך הכפתור המקורי המוסתר,
     "פרטים" = פתיחה/סגירה של התיאור בתוך הדף. בהאזנה מואצלת כי המגירה מתרנדרת מחדש. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('ccu-input')) return;
    var box = input.closest('.ccu');
    var add = box && box.querySelector('.ccu-add');
    if (!add) return;
    if (input.checked) {
      add.click();
      // אם ההוספה נכשלה והמגירה לא התרנדרה – מחזירים את הסימון
      setTimeout(function () { if (document.contains(input)) input.checked = false; }, 5000);
    }
  });

  // החלונית של "פרטים" ברוחב כל שורת המוצר (ולא רק עמודת הטקסט הצרה), והחץ שלה
  // מצביע על כפתור "פרטים"
  function placeVipPop(wrap, pop, btn) {
    // החלונית ממוקמת מעל מקום ששומרים לה מתחת לתג (padding), כך שהיא דוחפת את מה
    // שמתחת למטה – אבל לא מרחיבה את עמודת הטבלה (שאחרת הייתה דוחפת את המחירים הצידה)
    var row = wrap.closest('tr.cart-item') || wrap;
    var line = wrap.querySelector('.ccd-vip-line');
    var gap = 10;
    var rowBox = row.getBoundingClientRect();
    var wrapBox = wrap.getBoundingClientRect();
    pop.style.position = 'absolute';
    pop.style.top = ((line ? line.offsetHeight : 0) + 10) + 'px';
    pop.style.right = (wrapBox.right - (rowBox.right - gap)) + 'px';
    pop.style.width = (rowBox.width - gap * 2) + 'px';
    pop.style.maxWidth = 'none';
    pop.style.marginTop = '0';
    wrap.style.paddingBottom = (pop.offsetHeight + 14) + 'px';
    var popBox = pop.getBoundingClientRect();
    var btnBox = btn.getBoundingClientRect();
    var arrow = popBox.right - (btnBox.left + btnBox.width / 2) - 7;
    pop.style.setProperty('--ccd-arrow-right', Math.max(12, Math.min(arrow, popBox.width - 26)) + 'px');
  }

  // "פרטים" על שורת מארז ה-VIP בעגלה
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ccd-vip-btn, .ccd-vip-close');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = btn.closest('.ccd-vip');
    var pop = wrap.querySelector('.ccd-vip-pop');
    var info = wrap.querySelector('.ccd-vip-btn');
    var open = btn === info ? !pop.classList.contains('is-open') : false;
    pop.classList.toggle('is-open', open);
    info.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) placeVipPop(wrap, pop, info);
    else wrap.style.paddingBottom = '';
    // בטלפון החלונית יכולה להיפתח מאחורי אזור התשלום – גוללים את רשימת המוצרים כך שתיראה כולה
    if (open) {
      setTimeout(function () {
        try { pop.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (err) { pop.scrollIntoView(false); }
      }, 30);
    }
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.ccu-info-btn, .ccu-pop-close');
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest('.ccu');
    var pop = box && box.querySelector('.ccu-pop');
    var info = box && box.querySelector('.ccu-info-btn');
    if (!pop) return;
    var open = btn.classList.contains('ccu-info-btn') ? !pop.classList.contains('is-open') : false;
    pop.classList.toggle('is-open', open);
    if (info) info.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  function init() {
    update();
    var target = document.getElementById('CartDrawer') || document.body;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        var el = t.nodeType === 1 ? t : t.parentElement;
        if (el && el.closest && el.closest('#CartDrawer-Checkout')) continue; // השינוי שלנו
        var d = document.querySelector('cart-drawer');
        if (d) arrange(d);
        schedule();
        return;
      }
    }).observe(target, { childList: true, subtree: true, characterData: true });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, schedule);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ההדר: מסמן את העמוד כ"גלול" (html.claude-scrolled) – כך הטשטוש שמתחת להדר
   (assets/claude-theme-fixes-4.css) מופיע רק אחרי שגוללים, ולא בראש העמוד. */
(function () {
  'use strict';
  var root = document.documentElement;
  var ticking = false;
  function sync() {
    ticking = false;
    root.classList.toggle('claude-scrolled', window.scrollY > 4);
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(sync); }
  }, { passive: true });
  sync();
})();

/* גלריית המוצר בדסקטופ: לחיצה על החלק המציץ של התמונה הבאה (משמאל לתמונה)
   עוברת אליה – דרך התמונה הממוזערת הבאה, כך שהתבנית מעדכנת הכול כרגיל. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    if (window.innerWidth < 990 || !e.target.closest) return;
    var wrapper = e.target.closest('[id*="shop_product_details"] .shop-main-image-wrapper');
    if (!wrapper) return;
    var box = wrapper.querySelector('.shop-image-container');
    if (!box || e.clientX >= box.getBoundingClientRect().left) return;
    var section = wrapper.closest('[id*="shop_product_details"]');
    var thumbs = section.querySelectorAll('.shop-thumbnail');
    if (thumbs.length < 2) return;
    var current = -1;
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('active')) current = i;
    }
    e.preventDefault();
    e.stopPropagation();
    // בלי מעבר מעגלי – באחרונה אין לאן להמשיך
    if (current < thumbs.length - 1) thumbs[current + 1].click();
  }, true);

  // סמן של לחיצה מעל החלק המציץ
  document.addEventListener('mousemove', function (e) {
    if (window.innerWidth < 990 || !e.target.closest) return;
    var wrapper = e.target.closest('[id*="shop_product_details"] .shop-main-image-wrapper');
    if (!wrapper) return;
    var box = wrapper.querySelector('.shop-image-container');
    wrapper.style.cursor = box && e.clientX < box.getBoundingClientRect().left ? 'pointer' : '';
  }, { passive: true });
})();

/* גלריית ההירו מימין לשמאל (assets/product-gallery.js של התבנית):
   התמונות הבאות נמצאות משמאל, ולכן החלקת אצבע ימינה מביאה את הבאה ושמאלה – את הקודמת;
   ובלי מעבר מעגלי – מהאחרונה לא קופצים לראשונה ולהפך. */
(function () {
  'use strict';

  function patch(g) {
    if (!g || g.__claudeRtl) return;
    g.__claudeRtl = true;

    function order() {
      return g.visibleIndices && g.visibleIndices.length ? g.visibleIndices : g.mainImages.map(function (_, i) { return i; });
    }

    g.getNextVisibleIndex = function (cur) {
      var vis = order();
      var pos = vis.indexOf(cur);
      return pos === -1 ? vis[0] : vis[Math.min(pos + 1, vis.length - 1)];
    };

    g.getPrevVisibleIndex = function (cur) {
      var vis = order();
      var pos = vis.indexOf(cur);
      return pos === -1 ? vis[0] : vis[Math.max(pos - 1, 0)];
    };

    g.handleSwipeGesture = function () {
      var deltaX = g.touchEndX - g.touchStartX;
      if (Math.abs(deltaX) > g.swipeThreshold) {
        var target = deltaX > 0 ? g.getNextVisibleIndex(g.currentIndex) : g.getPrevVisibleIndex(g.currentIndex);
        if (target !== g.currentIndex) g.changeImage(target);
      }
      g.touchStartX = 0;
      g.touchEndX = 0;
    };
  }

  function run() {
    if (!window.ProductGallery || !window.ProductGallery.getAll) return false;
    var all = window.ProductGallery.getAll();
    all.forEach(patch);
    return all.length > 0;
  }

  function init() {
    if (run()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (run() || tries > 40) clearInterval(timer);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 100); });
})();

/* גלריית ההירו במובייל – התמונה עוקבת אחרי האצבע בזמן גרירה (translate על התמונה הנוכחית
   ועל השכנות), ובשחרור – חוזרת למקום בהחלקה (הכיוון והמעבר עצמו נקבעים ב-handleSwipeGesture
   המותאם למעלה; המיקומים הקבועים ב-claude-theme-fixes-4.css עם transform).
   בקצוות (לפני הראשונה / אחרי האחרונה) יש התנגדות, כך שברור שאין לאן להמשיך. */
(function () {
  'use strict';
  if (!window.matchMedia) return;
  var mobile = window.matchMedia('(max-width: 749px)');

  function setup(wrapper) {
    if (wrapper.__claudeDrag) return;
    wrapper.__claudeDrag = true;
    var box = wrapper.querySelector('.shop-image-container');
    if (!box) return;

    var drag = null;

    function imgs() {
      return Array.prototype.slice.call(box.querySelectorAll(':scope > .shop-image-zoom-wrapper > img.shop-main-image'));
    }

    function activeIndex(list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].parentElement.classList.contains('active')) return i;
      }
      return 0;
    }

    function setOffset(list, px, animate) {
      list.forEach(function (img) {
        if (animate) {
          img.style.removeProperty('transition');
        } else {
          img.style.setProperty('transition', 'none', 'important');
        }
        img.style.translate = px ? px + 'px 0' : '';
      });
    }

    wrapper.addEventListener('touchstart', function (e) {
      if (!mobile.matches || e.touches.length !== 1) { drag = null; return; }
      var list = imgs();
      var i = activeIndex(list);
      var group = [list[i - 1], list[i], list[i + 1]].filter(Boolean);
      drag = { x: e.touches[0].clientX, y: e.touches[0].clientY, dx: 0, horizontal: null, group: group, first: i === 0, last: i === list.length - 1 };
    }, { passive: true });

    wrapper.addEventListener('touchmove', function (e) {
      if (!drag || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - drag.x;
      var dy = e.touches[0].clientY - drag.y;
      if (drag.horizontal === null && Math.abs(dx) + Math.abs(dy) > 6) drag.horizontal = Math.abs(dx) > Math.abs(dy);
      if (!drag.horizontal) return;
      // התמונות הבאות משמאל: גרירה ימינה = הבאה, שמאלה = הקודמת. בקצה – התנגדות
      if ((dx > 0 && drag.last) || (dx < 0 && drag.first)) dx = dx * 0.25;
      drag.dx = dx;
      setOffset(drag.group, dx, false);
    }, { passive: true });

    function release() {
      if (!drag) return;
      var group = drag.group;
      drag = null;
      // מחזירים את האנימציה ומאפסים את ההזזה באותו רגע שהתבנית מחליפה תמונה (אותו touchend,
      // לפני שהדפדפן מצייר) – כך ההחלקה ממשיכה מהמקום שבו האצבע עזבה, בלי קפיצה
      setOffset(group, 0, true);
    }

    wrapper.addEventListener('touchend', release, { passive: true });
    wrapper.addEventListener('touchcancel', release, { passive: true });
  }

  function run() {
    document.querySelectorAll('[id*="shop_product_details"] .shop-main-image-wrapper').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 100); });
})();

/* קרוסלת הביקורות ב-Product Details: גלילה טבעית (scroll-snap ב-claude-theme-fixes-4.css)
   במקום ההזזה של התבנית. עוצרים את מאזיני הגרירה של התבנית (הם חוסמים את הגלילה הטבעית),
   והנקודות מתעדכנות לפי הכרטיס שבמרכז / גוללות אליו בלחיצה. */
(function () {
  'use strict';

  function setup(container) {
    if (container.__claudeNative) return;
    var track = container.querySelector('.customer-review-slides');
    if (!track) return;
    container.__claudeNative = true;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.customer-review-slide'));
    var dots = Array.prototype.slice.call(container.querySelectorAll('.pagination-dot'));

    // מאזיני התבנית יושבים על track – עוצרים את האירועים לפני שהם מגיעים אליו
    ['touchstart', 'touchmove', 'touchend', 'mousedown'].forEach(function (type) {
      container.addEventListener(type, function (e) { e.stopPropagation(); }, { capture: true, passive: true });
    });

    function centered() {
      var box = track.getBoundingClientRect();
      var mid = box.left + box.width / 2;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (s, i) {
        var b = s.getBoundingClientRect();
        var d = Math.abs(b.left + b.width / 2 - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    function syncDots() {
      var i = centered();
      dots.forEach(function (d, j) { if (d.classList.contains('active') !== (j === i)) d.classList.toggle('active', j === i); });
      slides.forEach(function (s, j) { if (s.classList.contains('active') !== (j === i)) s.classList.toggle('active', j === i); });
    }

    // סקריפטים של התבנית (וה-RTL fix) מסמנים נקודה משלהם גם אחרי הטעינה – מחזירים לנקודה הנכונה
    if (window.MutationObserver && dots.length) {
      new MutationObserver(function () { syncDots(); }).observe(dots[0].parentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; syncDots(); });
    }, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        var s = slides[i];
        if (!s) return;
        var box = track.getBoundingClientRect();
        var b = s.getBoundingClientRect();
        track.scrollBy({ left: (b.left + b.width / 2) - (box.left + box.width / 2), behavior: 'smooth' });
      }, true);
    });

    // מתחילים מהביקורת הראשונה (הימנית). התבנית מסמנת את האמצעית ב-DOMContentLoaded –
    // לכן מסנכרנים שוב אחרי שהעמוד נטען
    track.scrollLeft = 0;
    syncDots();
    setTimeout(syncDots, 0);
    window.addEventListener('load', function () { track.scrollLeft = 0; syncDots(); });

    // ---- קרוסלה אוטומטית (הגדרות הבלוק: data-autoplay / data-autoplay-interval) ----
    // זזה רק כשהקרוסלה על המסך והטאב גלוי. נגיעה/לחיצה על ביקורת עוצרת; שחרור ממשיך
    // (עם ספירה מחדש של המרווח). גלילה ידנית של הלקוח גם מאפסת את הספירה.
    if (container.getAttribute('data-autoplay') === 'true' && slides.length > 1) {
      var intervalMs = Math.max(1000, (parseFloat(container.getAttribute('data-autoplay-interval')) || 5) * 1000);
      var held = false;
      var timer = null;
      var autoScrollUntil = 0;

      var snapTimer = null;
      function restoreSnap() {
        if (snapTimer) { clearTimeout(snapTimer); snapTimer = null; }
        track.style.scrollSnapType = '';
      }
      function scrollToSlide(i) {
        var s = slides[i];
        if (!s) return;
        var box = track.getBoundingClientRect();
        var b = s.getBoundingClientRect();
        autoScrollUntil = Date.now() + 1200;
        // scroll-snap mandatory "תופס" גלילה חלקה שעוברת יותר מכרטיס אחד (החזרה מהאחרון לראשון)
        // – מכבים אותו לרגע הגלילה ומחזירים מיד אחריה
        if (snapTimer) clearTimeout(snapTimer);
        track.style.scrollSnapType = 'none';
        track.scrollBy({ left: (b.left + b.width / 2) - (box.left + box.width / 2), behavior: 'smooth' });
        snapTimer = setTimeout(restoreSnap, 900);
      }

      function onScreen() {
        if (document.visibilityState === 'hidden') return false;
        var r = container.getBoundingClientRect();
        var h = window.innerHeight || document.documentElement.clientHeight;
        return r.bottom > 0 && r.top < h;
      }

      function tick() {
        if (held || !onScreen()) return;
        scrollToSlide((centered() + 1) % slides.length);
      }

      function restart() {
        if (timer) clearInterval(timer);
        timer = setInterval(tick, intervalMs);
      }

      function hold() { held = true; restoreSnap(); }
      function release() { if (!held) return; held = false; restart(); }

      ['touchstart', 'pointerdown', 'mousedown'].forEach(function (type) {
        container.addEventListener(type, hold, { capture: true, passive: true });
      });
      ['touchend', 'touchcancel', 'pointerup', 'pointercancel', 'mouseup'].forEach(function (type) {
        document.addEventListener(type, release, { capture: true, passive: true });
      });
      // גלילה שלא יזמנו אנחנו = הלקוח גולל – מתחילים לספור מחדש
      track.addEventListener('scroll', function () { if (Date.now() > autoScrollUntil) restart(); }, { passive: true });

      restart();
      container.__claudeAutoplay = { restart: restart, stop: function () { if (timer) clearInterval(timer); timer = null; }, tick: tick };
    }
  }

  function run() {
    document.querySelectorAll('[id*="shop_product_details"] .customer-review-carousel-container').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 0); });
  } else {
    run();
  }
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 100); });
})();

/* בלוק הדירוג "1,329 ביקורות" (Image Rating): הטקסט באותו גודל של הכוכבים.
   גודל הכוכבים נקבע בעורך (ומשתנה במובייל), לכן מודדים אותו ומעדכנים את
   המשתנה --claude-rating-text שהכלל ב-claude-theme-fixes-3.css משתמש בו. */
(function () {
  'use strict';

  // משווים את מה שרואים: גובה צורת הכוכב (בלי השוליים הפנימיים של ה-SVG) מול גובה
  // האותיות בפועל (נמדד עם canvas לפי הפונט של הטקסט) – ולא גובה "קופסה" מול גודל פונט.
  var canvas = document.createElement('canvas').getContext('2d');

  function glyphHeight(star) {
    var svg = star.tagName === 'svg' ? star : star.querySelector('svg');
    var shape = svg && svg.querySelector('path, polygon');
    var box = star.getBoundingClientRect().height;
    if (!svg || !shape || !box) return 0;
    try {
      var vb = svg.viewBox.baseVal;
      var bb = shape.getBBox();
      if (vb && vb.height && bb.height) return box * (bb.height / vb.height);
    } catch (e) {}
    return box * 0.7;
  }

  function inkRatio(el) {
    var cs = getComputedStyle(el);
    var fs = parseFloat(cs.fontSize) || 14;
    try {
      canvas.font = cs.fontWeight + ' ' + fs + 'px ' + cs.fontFamily;
      var m = canvas.measureText('4.8 אלפי לקוחות');
      var ink = m.actualBoundingBoxAscent + m.actualBoundingBoxDescent;
      if (ink > 0) return ink / fs;
    } catch (e) {}
    return 0.75;
  }

  var MIN_TEXT = 12; // הטקסט לא יורד מתחת ל-12px – אם הכוכבים קטנים מזה, הם גדלים אליו

  function sync() {
    document.querySelectorAll('[id*="shop_product_details"] .imgr-container').forEach(function (box) {
      var star = box.querySelector('.imgr-star, .imgr-star-half-container');
      var text = box.querySelector('.imgr-rating-value strong, .imgr-rating-value, .imgr-rating-text');
      if (!star || !text) return;

      // מודדים את הגודל המקורי של הכוכב (מהעורך) – בלי ההגדלה שלנו – כדי שהחישוב
      // יהיה זהה בכל פעם ולא "ירדוף את עצמו"
      var wasSynced = box.classList.contains('claude-rating-synced');
      if (wasSynced) box.classList.remove('claude-rating-synced');
      var starBox = star.getBoundingClientRect().height;
      var glyph = glyphHeight(star);
      if (wasSynced) box.classList.add('claude-rating-synced');
      if (!glyph || !starBox) return;

      var frac = glyph / starBox;
      var ratio = inkRatio(text);
      var fs = glyph / ratio;
      var starSize = starBox;
      if (fs < MIN_TEXT) {
        fs = MIN_TEXT;
        starSize = (fs * ratio) / frac;
      }
      var fsVal = Math.round(fs * 10) / 10 + 'px';
      var starVal = Math.round(starSize * 10) / 10 + 'px';
      // כותבים רק אם משהו באמת השתנה – כדי לא להפעיל שוב את עצמנו
      if (box.style.getPropertyValue('--claude-rating-text') !== fsVal) box.style.setProperty('--claude-rating-text', fsVal);
      if (box.style.getPropertyValue('--claude-rating-star') !== starVal) box.style.setProperty('--claude-rating-star', starVal);
      if (!box.classList.contains('claude-rating-synced')) box.classList.add('claude-rating-synced');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  window.addEventListener('load', sync);
  window.addEventListener('resize', sync);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
  document.addEventListener('shopify:section:load', function () { setTimeout(sync, 50); });
  // בעורך הערכה הבלוק מתרנדר מחדש – מסנכרנים כשמופיע בלוק דירוג חדש (ולא על כל שינוי סגנון)
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function (list) {
      var relevant = list.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && (n.matches('.imgr-container') || n.querySelector('.imgr-container'));
        });
      });
      if (!relevant || pending) return;
      pending = setTimeout(function () { pending = null; sync(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* הדגשה שנפרסת (.claude-hl): מתחילה רק כשהלקוח גולל ומגיע לטקסט – לא בטעינה.
   כל אלמנט נבדק בכל גלילה; ברגע שהוא בתוך המסך (אחרי שהייתה גלילה) – מקבל is-on פעם אחת.
   גם אחרי רינדור מחדש בעורך. */
(function () {
  'use strict';
  var pending = [];
  var seen = new WeakSet();
  var scrolled = false;

  function inView(el) {
    var b = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    var w = window.innerWidth || document.documentElement.clientWidth;
    if (!(b.bottom > 0 && b.top < h * 0.88 && b.width > 0)) return false;
    // בתוך קרוסלת הביקורות: רק כשהכרטיס עצמו הוא זה שצופים בו – לפחות 70% מרוחבו
    // בתוך המסך (ובתוך אזור הגלילה של הקרוסלה). כרטיס שמציץ מהצד לא מתחיל.
    var slide = el.closest('.customer-review-slide');
    if (slide) {
      var s = slide.getBoundingClientRect();
      var track = slide.closest('.customer-review-slides');
      var left = 0, right = w;
      if (track) { var tr = track.getBoundingClientRect(); left = Math.max(left, tr.left); right = Math.min(right, tr.right); }
      var visible = Math.min(s.right, right) - Math.max(s.left, left);
      return s.width > 0 && visible / s.width >= 0.7;
    }
    return b.right > 0 && b.left < w;
  }

  function check() {
    if (!scrolled) return;
    pending = pending.filter(function (el) {
      if (!document.contains(el) || el.classList.contains('is-on')) return false;
      if (inView(el)) { el.classList.add('is-on'); runSweep(el); return false; }
      return true;
    });
  }

  // מפצל את הטקסט למילים, וכל מילה מקבלת משך והשהיה לפי אורכה – כך הרקע זוחל
  // מילה אחרי מילה במהירות אחידה, וסך הזמן = --hl-speed (זמן הפריסה מהעורך)
  // הפריסה עצמה מונעת ב-JS (requestAnimationFrame) ולא ב-CSS transition: בסמסונג עם
  // "הסרת אנימציות" הדפדפן מקצר כל transition לרגע אחד, וכך הרקע נפרס "במכה". כאן אנחנו
  // מחשבים בכל פריים כמה אחוז מכל מילה צריך להיות צבוע, לפי הזמן שעבר.
  function runSweep(el) {
    var words = el.classList.contains('claude-hl-split') ? [].slice.call(el.querySelectorAll('.claude-hl-w')) : [el];
    var total = parseFloat(getComputedStyle(el).getPropertyValue('--hl-speed')) || 4;
    var chars = el.textContent.replace(/\s+$/, '').length || 1;
    var at = 0;
    var slots = words.map(function (w) {
      var d = words.length === 1 ? total : (total * w.textContent.length) / chars;
      var s = { el: w, start: at, dur: d };
      at += d;
      return s;
    });
    var t0 = null;
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var t = (ts - t0) / 1000;
      var done = true;
      slots.forEach(function (s) {
        var p = (t - s.start) / s.dur;
        p = p < 0 ? 0 : p > 1 ? 1 : p;
        s.el.style.backgroundSize = (p * 100).toFixed(2) + '% 100%';
        if (p < 1) done = false;
      });
      if (!done) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function splitWords(el) {
    if (el.classList.contains('claude-hl-split') || el.children.length) return;
    var text = el.textContent;
    var parts = text.match(/\S+\s*/g);
    if (!parts || parts.length < 2) return;
    var frag = document.createDocumentFragment();
    parts.forEach(function (w) {
      var span = document.createElement('span');
      span.className = 'claude-hl-w';
      span.textContent = w;
      frag.appendChild(span);
    });
    el.textContent = '';
    el.appendChild(frag);
    el.classList.add('claude-hl-split');
  }

  function arm() {
    // אם העמוד כבר גלול כשהסקריפט נטען (הלקוח גלל לפני שהסקריפט רץ, או שהדפדפן שחזר
    // מיקום גלילה) – נחשב כגלילה
    if (!scrolled && (window.scrollY || window.pageYOffset || 0) > 10) scrolled = true;
    document.querySelectorAll('.claude-hl').forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      splitWords(el);
      pending.push(el);
    });
    check();
  }

  function onScroll() {
    scrolled = true;
    check();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('touchmove', onScroll, { passive: true });
  window.addEventListener('wheel', onScroll, { passive: true });
  window.addEventListener('resize', check);
  // גלילה פנימית (קרוסלת הביקורות) – רק בודקים מחדש, בלי לסמן שהעמוד נגלל
  document.addEventListener('scroll', function () { if (scrolled) check(); }, { passive: true, capture: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm); else arm();
  window.addEventListener('load', arm);
  document.addEventListener('shopify:section:load', function () { setTimeout(arm, 100); });
  if (window.MutationObserver) {
    new MutationObserver(function () { arm(); }).observe(document.body, { childList: true, subtree: true });
  }
})();
